<template>
  <div class="container mt20" v-loading="isLoading">
    <div class="relative">
      <el-breadcrumb separator-class="el-icon-arrow-right" class="containers mb10">
        <el-breadcrumb-item :to="{ path: '/qbank' }">题库中心</el-breadcrumb-item>
        <el-breadcrumb-item><span class="hover">题库详情</span></el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div v-if="detail">
      <div class="BGwhite pad24 radius8 gray1 flex nowrap initial relative detail">
        <img src="@/assets/img/home/57.png" class="ImgPath" alt="" />
        <div class="ml30 flex1 right-box">
          <p>
            <span class="ClassifyName">#{{ detail.ClassifyName }}</span>
          </p>
          <p class="ellipsis2 b500 size30 mt10 ohide">
            {{ detail.ExerciseName }}
          </p>
          <div class="flex between mt20">
            <div class="flex my-star">
              <span class="mr5 red">{{ detail.StarNum }}</span>
              <el-rate :value="detail.StarNum" disabled :colors="['#FFC000', '#FFC000', '#FFC000']"
                disabled-void-color="#CCCCCC"></el-rate>
              <p class="height14px width1px BG00 opacity2 ml30 mr30"></p>
              <img src="@/assets/img/home/4.png" alt="" class="mr5 user" />
              <span class="Corange ml2">{{ detail.StudyView }}</span>
              <p class="height14px width1px BG00 opacity2 ml30 mr30"></p>
              <img src="@/assets/img/home/18.png" alt="" class="time mr5" />
              <span class="Corange ml2">有效期：{{ detail.ValidityDay }}</span>
              <p class="height14px width1px BG00 opacity2 ml30 mr30"></p>
              <img src="@/assets/img/home/58.png" alt="" class="time mr5" />
              <span class="Corange ml2">题量：{{ detail.TotalNum }}</span>
            </div>
          </div>
          <div class="flex Price">
            <div class="nowrap">
              <span v-if="detail.Price > 0">¥</span>
              <span class="red">{{
                detail.Price > 0 ? detail.Price : "免费"
              }}</span>
              <el-button v-if="!detail.IsBuyed && detail.Price > 0" type="primary" class="ml50 pay"
                @click="pay">立即购买</el-button>
              <el-button v-else type="primary" class="ml50 pay" @click="toExam">开始练习</el-button>
            </div>
          </div>
          <el-progress :text-inside="true" v-if="detail.StudyProgress" text-color="white" :stroke-width="22"
            :percentage="detail.StudyProgress" class="myProgress"></el-progress>
          <div class="flex size16 absolute r b mr25 mb40">
            <template v-if="detail">
              <el-button class="testBtn" @click="fav()">
                <img v-if="detail.IsFav" src="@/assets/img/home/64.png" alt="" />
                <img v-else src="@/assets/img/home/17.png" alt="" />
                {{ detail.IsFav == false ? "我要收藏" : "取消收藏" }}</el-button>
            </template>
          </div>
        </div>
      </div>
      <div class="flex between start nowrap containers mt20 mb80">
        <div class="mr20" style="flex: 1">
          <ul class="flex C666 b500 part04 size16 BGwhite radius8 gray1 mt10">
            <template>
              <li :class="{ Con: tab == 1 }" @click="tab = 1">介绍</li>
              <li v-if="detail.IsComment" :class="{ Con: tab == 4 }" @click="tab = 4">
                评论
              </li>
            </template>
          </ul>
          <div class="pad25 radius8 ohide BGwhite radius8 gray1 mt1 detail-tab-box" v-if="detail">
            <div v-show="tab == 1" class="jieshao">
              <p v-if="detail.SuitCrowd > 0" class="my-b-tit">适用人群</p>
              <div class="mt10">{{ detail.SuitCrowd }}</div>
              <p v-if="keywords.length > 0" class="my-b-tit mt20">关键词</p>
              <div class="keywords mt10">
                <span v-for="(tag, k) in keywords" :key="tag + k">
                  #{{ tag }}
                </span>
              </div>
            </div>

            <comment v-if="tab == 4" :id="detail.ExerciseID" :data="detail" @update="getDetail">
            </comment>
          </div>
        </div>
        <rightSide class="width290px mt10" v-if="!isLoading" />
      </div>
    </div>
  </div>
</template>

<script>
import { Exercise_GetDetail } from "@/api/qbank";
import { Fav_Save } from "@/api/common";
import { CreateOrders } from "@/api/order";
import comment from "./child/comment.vue";
import rightSide from "./child/rightSide.vue";

export default {
  name: "qbankDetail",
  components: {
    comment,
    rightSide,
  },
  data() {
    return {
      tab: 1,
      isLoading: false,
      detail: null,
      keywords: [],
    };
  },
  watch: {
    "$route.query.tab"(newValue) {
      if (newValue === undefined) {
        this.$router.go(0);
      }
    },
    "$route.query.ExerciseID"(newValue) {
      if (newValue) {
        this.getDetail();
      }
    },
    tab(v) {
      this.$router.replace({
        query: {
          ...this.$route.query,
          tab: v,
        },
      });
    },
  },
  created() {
    const { tab } = this.$route.query;
    if (tab) {
      this.tab = Number(tab);
    }

    this.getDetail();
  },
  methods: {
    toExam() {
      this.$router.push({
        path: "/qbankCreate",
        query: {
          ExerciseID: this.$route.query.ExerciseID,
        },
      });
    },
    pay() {
      CreateOrders({
        RelatedType: 3,
        RelatedID: this.$route.query.ExerciseID,
        ShareAuthKey: this.$route.query.ShareAuthKey,
      }).then((res) => {
        if (res.code == 0) {
          this.$router.push({
            path: "/confirmOrder",
            query: {
              OrdersID: res.data.OrdersID,
            },
          });
        }
      });
    },
    fav() {
      // 1收藏 0取消
      const data = {
        RelatedType: 3,
        RelatedID: this.detail.ExerciseID,
        StatusID: this.detail.IsFav ? 0 : 1,
      };
      Fav_Save(data).then(() => {
        this.$message({
          message: this.detail.IsFav ? "取消收藏成功" : "收藏成功",
          type: "success",
        });
        this.detail.IsFav = !this.detail.IsFav;
      });
    },

    getDetail(reload = false) {
      this.detail = null;
      if (!reload) {
        this.isLoading = true;
      }
      Exercise_GetDetail({
        ExerciseID: this.$route.query.ExerciseID,
      })
        .then((res) => {
          this.isLoading = false;
          this.detail = res.data;
          this.detail.MyEvaluateStarNum = res.data.MyEvaluateStarNum
            ? Number(this.detail.MyEvaluateStarNum)
            : 0;
          this.keywords = this.detail.Keywords
            ? this.detail.Keywords.split("；")
            : [];
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.detail {
  padding-top: 40px;
}

.detail-tab-box {
  min-height: 900px;
}

.ImgPath {
  width: 92px;
  height: 87px;
}

.Price {
  position: absolute;
  bottom: 40px;
  color: #e12a14;
  font-size: 20px;
  font-weight: bold;

  .red {
    font-weight: bold;
    font-size: 24px;
    color: #e12a14;
  }

  .pay {
    width: 144px;
    height: 52px;
    font-size: 18px;
    background: #1d79ff;
    border-radius: 6px;
  }
}

.right-box {
  margin-top: 5px;
  height: 230px;

  .ClassifyName {
    background: #e5f0ff;
    border-radius: 6px;
    font-size: 16px;
    color: #1d79ff;
    padding: 5px 10px;
  }

  .Body {
    margin-top: 10px;
    font-size: 30px;
    color: #333333;
    font-weight: bold;
  }

  .my-star {
    font-size: 20px;
    display: flex;
    align-items: center;

    .Corange {
      color: #666666;
      font-size: 18px;
      font-weight: 400;
    }

    .user {
      width: 12px;
      height: 17px;
    }

    .time {
      width: 17px;
      height: 17px;
    }
  }
}

.red {
  color: #e12a14;
  font-weight: bold;
}

.jieshao {
  padding-left: 40px;
  font-weight: 400;
  font-size: 18px;
  color: #666666;

  .keywords {
    span {
      margin-right: 20px;
    }
  }
}

.testBtn {
  border-radius: 50px;

  img {
    width: 24px;
    height: 24px;
    margin-right: 5px;
    margin-left: -5px;
  }
}
</style>
